"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportShow = void 0;
/** *
 * 获取曝光上报参数
 * report-show="show_{组件名}"
 * report-ext1="{组件顺序}"
 * report-ext2="{组件标题}"
 *  */
const reportShow = array => {
  const reportObj = {};
  const showName = array && array[0];
  const ext1 = array && array[1];
  const ext2 = array && array[2];
  const ext3 = array && array[3];
  reportObj['report-show'] = showName;
  reportObj['report-ext1'] = ext1 || 0;
  reportObj['report-ext2'] = ext2 || '';
  if (ext3) {
    reportObj['report-ext3'] = ext3;
  }
  return reportObj;
};
exports.reportShow = reportShow;